import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

export type DropdownProps = DropdownMenu.DropdownMenuProps;

const Dropdown = ({ children, ...props }: DropdownProps) => (
  <DropdownMenu.Root {...props}>{children}</DropdownMenu.Root>
);

export default Dropdown;
